<template>
<div class="phone_footer_box">
    <!-- 内容 -->
    <div class="footer">
      <!-- TOP区块 -->
      <div class="footer_top">
        <div class="img_box">
          <img src="../../assets/img/common/qr_code.png" alt="">
        </div>
        <!--台易購金融科技股份有限公司 -->
        <div class="company_box">

          <div class="com_topbox">

            <div>
              <img src="../../assets/img/common/logo_company.png" alt="" srcset="">
            </div>
            <div>
              <h3>台易購金融科技股份有限公司</h3>
              <p>各國網路商城代付．微信/支付寶儲值．台灣合法在地永續經營</p>
            </div>

          </div>

          <p>電話：02 2212 5312　|　傳真：02 2212 3192　|　郵箱：TYG8899@outlook.com</p>
          <p>地址：新北市231新店區安興路117號12樓之7</p>

          <!-- 合作公司 -->
          <div class="logo_partner">
            <img src="../../assets/img/common/logo_partner01.png" alt="">
            <img src="../../assets/img/common/logo_partner02.png" alt="">
            <img src="../../assets/img/common/logo_partner03.png" alt="">
            <img src="../../assets/img/common/logo_partner04.png" alt="">
            <img src="../../assets/img/common/logo_partner05.png" alt="">
          </div>

        </div>
      </div>
      <!-- BOTTOM区块 -->
      <div class="footer_bottom">
        <ul>
          <li>about <span></span> </li>
          <li @click="testClick('1')">關於我們</li>
          <li>使用指南</li>
          <li>常見問題</li>
          <li>隱私政策</li>
        </ul>
         <ul>
          <li>product <span></span> </li>
          <li>收款工具</li>
          <li>付款工具</li>
          <li>店舖管理</li>
          <li>金流服務</li>
        </ul>
         <ul>
          <li>service <span></span> </li>
          <li>支援中心</li>
          <li>會員條款</li>
          <li>店舖管理</li>
          <li>商務合作</li>
        </ul>
      </div>

    </div>
    <!-- logo_sns -->
    <div class="logo_sns">
      <img src="../../assets/img/common/sns.png" alt="">
    </div>
    <!-- copyright -->
  <!-- copyright -->
  <div class="copyright">
    COPYRIGHT © TYG Financial Technology INC. ALL RIGHTS RESERVED.
  </div>
</div>
</template>

<script>
export default {
  name: 'PhoneFooter',
  props: {
  },
  data() {
    return {
    }
  },
  methods: {
    testClick(id){
      this.$router.push("/test/" + id);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.footer {

}
/* TOP */
.footer_top {
  padding: 3.3vw 0;
  background: #777777;
  color: white;
  display: flex;
  justify-content: center;
}
.img_box >img {
  width: 17.3vw;
}
.company_box >p {
  padding-top: 1.6vw;
}
.com_topbox {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2.1vw;
}
.com_topbox h3 {
  margin-bottom: 1vw;
  font-weight: bold;
}
.img_box {
  margin-right: 4vw;
}
.com_topbox img {
  width: 5.3vw;
  margin-right: 2vw;
}
.logo_partner {
  margin-top: 1vw;
}
.logo_partner >img+img {
  margin-left: 2vw;
}
/* BOTTOM */
.footer_bottom {
  display: flex;
  justify-content: center;
  font-size: 2.1vw;
  color: #777777;
  margin: 8vw 0;
}
.footer_bottom ul {
  padding: 0 6vw;
  text-align: center;
}
.footer_bottom ul+ul {
  border-left: 1px solid #777;
}
.footer_bottom ul li:first-child {
  color: #777777;
  font-weight: bold;
  font-size: 2.5vw;
  letter-spacing: 2px;
  position: relative;
}
.footer_bottom ul li span {
  position: absolute;
  bottom: 0px;
  left: 0px;
  display: block;
  width: 100%;
  height: 50%;
  background: #e4e4e4;
  z-index: -2;
}
.footer_bottom ul li+li {
  margin-top: 2.7vw;
}
/* logo_sns */
.logo_sns {
  display: flex;
  justify-content: center;
  margin-bottom: 8vw;
}
/* copyright */
  .copyright {
    color: white;
    background: #777777;
    padding: 1.4vw 0;
    font-weight: bold;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }

    /* 768px */
@media screen and (min-width:769px){
  /* 显示/隐藏 */
  .phone_footer_box {
    display: none;

  }
}
</style>
